import { render, staticRenderFns } from "./Conclusion.vue?vue&type=template&id=bc30fbf8&scoped=true"
import script from "./Conclusion.vue?vue&type=script&setup=true&lang=ts"
export * from "./Conclusion.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Conclusion.vue?vue&type=style&index=0&id=bc30fbf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc30fbf8",
  null
  
)

export default component.exports